const restuarant_problem = `Hey Petteri,
I had the most disappointing experience at a restaurant today, and I just had to share it with you. 
Everything seemed to go wrong. 
First, the service was incredibly slow, and it took ages for our food to arrive. 
Then, when it finally did, my order was completely wrong. It felt like a series of unfortunate events.
I was really looking forward to enjoying a nice meal, but the whole experience left me feeling frustrated and let down. 
It's such a shame because I had heard good things about the place before.
Right now, I'm thinking of reaching out to the restaurant management to express my concerns and see if they can make it up somehow. 
I also want to give them some feedback so they can improve their services for other customers. 
Hopefully, they'll take my feedback seriously and work on making things better.
I'll let you know how it goes. 
Thanks for listening!
Take care`;

export default restuarant_problem;